import React from "react";
import { RED } from "../../constants";
import Banner from "../shared/Banner";

interface ErrorBannerProps {
  error: string;
  handleBannerDismiss: () => void;
  showBanner: boolean;
}

export const AdhocAgreementsErrorBanner: React.FC<ErrorBannerProps> = ({
  error,
  handleBannerDismiss,
  showBanner
}) => {
  const bannerMessage = `Something went wrong: ${error}`;
  const bannerBgColor = RED;

  return showBanner ? (
    <Banner
      message={bannerMessage}
      backgroundColor={bannerBgColor}
      showDismissButton={true}
      handleBannerDismiss={() => handleBannerDismiss()}
    />
  ) : (
    <></>
  );
};
